import { useState, useEffect } from   'react';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { FaArrowAltCircleRight, } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';

function BotonEditar(row, Editar) {
    return (
        <div>
            <div className="btn-group">
                <button type="button" className="btn btn-info" onClick={() => Editar(row)} 
                    data-tooltip-id='tooltiparriba'
                    data-tooltip-content="Editar">
                    <FaArrowAltCircleRight/>
                </button>
            </div>
            
        </div>
    );
}

export default function AyudasRol(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [ayudasRol, setAyudasRol] = useState([]);
    const [ayudas, setAyudas] = useState([]);
    const [roles, setRoles] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const columns = [
        {
            name: 'Acciones',
            cell: row => BotonEditar(row, Editar),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'7%' },
        { name: 'Id ayuda', selector: row => row.ayuAyudaid, sortable: true, width: '10%'},
        { name: 'Ayuda', selector: row => row.ayuAyuda, sortable: true, width: '30%'},
        { name: 'Id rol', selector: row => row.ayuRolid, sortable: true, width: '10%'},
        { name: 'Rol', selector: row => row.rol, sortable: true, width: '20%'},
        { name: 'Estado', selector: row => row.ayuActivo?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];
    useEffect(() => {
        fetchData();
        fetchAyudas();
        fetchRoles();
    }, []);
    const fetchData = async () => {
        const url = '/parametros/listarayudasrol';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setAyudasRol(result.ayudasPorRol);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const fetchAyudas = async () => {
        const url = '/parametros/listarayudasactivas';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setAyudas(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const fetchRoles = async () => {
        const url = '/parametros/listarroles';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setRoles(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function Editar (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('ayuRolid', row.ayuRolid);
        setValue('ayuAyudaid', row.ayuAyudaid);
        setValue('ayuActivo', row.ayuActivo);
    };
    const Nuevo = () =>  {
        setValue('id', 0);
        setValue('ayuRolid', 0);
        setValue('ayuAyudaid', 0);
        setValue('ayuActivo', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarayudarol';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data));
                Nuevo();
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('ayuRolid', 0);
        setValue('ayuAyudaid', 0);
        setValue('ayuActivo', false);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader  
                title="Ayudas por rol"
                idCabezaFamilia="1"
                url="/parametros"
                nombreurl="Parametros"
                nombreform=" Ayudas por rol"
            />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario Ayudas por roles</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor="ayuAyudaid">Ayudas</label>
                                                <select id="ayuAyudaid" className='form-control' {...register('ayuAyudaid', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {ayudas.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.id} {option.ayuAyuda}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.ayuAyudaid && <p style={{color: 'red'}}>Seleccione ayuda</p>}
                                            </div>    
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor="ayuRolid">Roles</label>
                                                <select id="ayuRolid" className='form-control' {...register('ayuRolid', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {roles.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                       {option.id}  {option.rolRol}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.ayuRolid && <p style={{color: 'red'}}>Seleccione Rol</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('ayuActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <div className='row'>
                                    <div className='col-md-2'>
                                        <button type="button" className='form-control' onClick={Nuevo}>Nuevo</button>
                                    </div>
                                </div>
                                
                                <DataTable
                                    title="Lista de ayudas por rol"
                                    columns={columns}
                                    data={ayudasRol}
                                    progressPending={Cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}